
import Base from '@/shared/app/ui/Base.vue';
import Component from 'vue-class-component';

@Component
export default class AutoAbsolute extends Base {
  mounted() {
    /*  */
  }

  // get containerStyle() {
  //   return {
  //     'flex-direction': this.config.vertical ? 'column' : 'row',
  //     'align-items': this.config.alignItems || 'stretch',
  //     'justify-content': this.config.justifyContent || 'flex-start',
  //     padding: this.config.padding || '0',
  //   };
  // }

  slotStyle(name: string) {
    const style: { [property: string]: string } = {};
    if (this.config[`${name}Height`])
      style.height = this.config[`${name}Height`].toString();
    if (this.config[`${name}Width`])
      style.width = this.config[`${name}Width`].toString();
    if (this.config[`${name}Top`])
      style.top = this.config[`${name}Top`].toString();
    if (this.config[`${name}Right`])
      style.right = this.config[`${name}Right`].toString();
    if (this.config[`${name}Bottom`])
      style.bottom = this.config[`${name}Bottom`].toString();
    if (this.config[`${name}Left`])
      style.left = this.config[`${name}Left`].toString();
    if (this.config[`${name}ZIndex`])
      style.zIndex = this.config[`${name}ZIndex`].toString();
    return style;
  }

  isDoneListened(slotName: string) {
    return this.config[`${slotName}_done`] === '1';
  }
}
